<template>
    <div id="defaultwerte">
        <form>
            <div id="container">
                <div id="lines" v-for="(value, key) in this.benutzerDefaults" :key="key">
                    <div id="line">
                        <h2>{{ this.woerterSplitten(key) }}</h2>
                        <label class="switch">
                            <input type="checkbox" v-model="benutzerDefaults[key]" :checked="(value=='1')?true:false" />
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
        </form>
        <div>
            <button @click="saveDefaults">Speichern</button>
        </div>
    </div>
</template>
  
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
import Swal from 'sweetalert2';
import {Benutzer} from '@/backend_controller/benutzer.js'

export default {
    name: "defaultwerte",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            benutzerDefaults: { },
        };
    },
    methods: {
        async getBenutzerDefaults() {
            try{
                var konvKey = this.$route.params.id.replace(":","");
                const response = await axios.get(
                    'https://feuerwehr-server.org:5000/defaultwerte',
                    { params: { konvKey: konvKey } }
                );
                //return response.data;
                console.log(response.data);
                delete response.data.email;

                for(var [key,value] of Object.entries(response.data)){
                    if(value == 1){
                        response.data[key] = true;
                    } else{
                        response.data[key] = false;
                    }
                }
                console.log(response.data)
                return response.data;
            } catch (err){
                console.log(err);
                return false;
            }
        },
        async saveDefaults() {
            var benutzer = await this.getBenutzer();
            var updatedData = this.benutzerDefaults;
            updatedData["email"] = benutzer.email;

            console.log(updatedData);
            try {
                const response = await axios.put('https://feuerwehr-server.org:5000/updateDefaultwerte', updatedData);
                console.log(response.data);
                Swal.fire("Speichern erfolgreich!", "","success")
                //return response.data;
            } catch (err) {
                console.error(err);
                //return false;
            }
            delete updatedData.email;
            // Füge hier deine Logik zum Speichern der Daten ein
        },
        woerterSplitten(word){
            return word.replace(/([a-z])([A-Z])/g, '$1 $2');
        },
        async getBenutzer() {
            var konvKey = this.$route.params.id.replace(":", "");
            
            const response = await Benutzer.getSingleWithKonvKey(konvKey);
            if(response == false){
                return false;
            } else{
                return response;
            }
        },
    },
    async created() {
        this.benutzerDefaults = await this.getBenutzerDefaults();
        //await this.getBenutzerDefaults();
    },
};
</script>
  
<style lang="scss">
#defaultwerte {
    margin-top: 5.5rem;
    //max-height: 500px;
    height: 90vh;
    overflow-y: auto;
    background-color: white;

    #defaultwerte div {
        margin-bottom: 10px;
    }

    #defaultwerte label {
        margin-right: 10px;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked+.slider {
        //background-color: #2196F3;
        background-color: #0059ff;
    }

    input:focus+.slider {
        //box-shadow: 0 0 1px #2196F3;
        box-shadow: 0 0 1px #0059ff;
    }

    input:checked+.slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    h2{
        display: inline-block;
        margin: 0;
        margin-right: 2rem;
        color: black;
    }

    @media screen and (max-width: 768px) {
        h2 {
            font-size: 1.2rem; /* Beispiel für die kleinere Schriftgröße - anpassen nach Bedarf */
        }

        
    }

    #lines{
        display: flex;
        justify-content: center;
    }

    #line{
        margin-top: 1rem;
        display: flex;
        align-items: center;
        display: flexbox;
        justify-content: space-between;
        max-width: 25rem;
        width: 85%;
    }

    button{
        font-size: x-large;
        border: solid #4457ff 1px;
        border-radius: 5px;
        background-color: #001aff;
        color: white;
        padding: 0.3rem;
        margin-top: 1.5rem;
    }
}

@media screen and (max-height: 768px) {
    #defaultwerte{
        height: 550px !important;
    }
}
</style>